var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devicestatus commonborder flex_row"},[_c('div',{staticClass:"num"},[_vm._v("总设备："),_c('b',[_vm._v(_vm._s(_vm.totalDev))]),_vm._v("台")]),_c('div',{staticClass:"echarts",attrs:{"id":"devicestatus_pie1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }